import React, { useState } from "react";
import api from "../api/axios";

const AddNotice = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    isHome: 1,
    status_Info: 1,
    app_Web: "",
    remark: "",
    upload1: null,
    upload2: null,
    upload3: null,
    upload4: null,
    upload1_name: "",
    upload2_name: "",
    upload3_name: "",
    upload4_name: ""
  });

  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "file") {
      setFormData({ ...formData, [name]: files[0] });
    } else if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");

    const data = new FormData();
    data.append("Name", formData.name);
    data.append("Description", formData.description);
    data.append("IsHome", formData.isHome ? 1 : 0);
    data.append("Status_Info", formData.status_Info);
    data.append("App_Web", formData.app_Web);
    data.append("Remark", formData.remark);

    if (formData.upload1) data.append("Upload1", formData.upload1);
    if (formData.upload2) data.append("Upload2", formData.upload2);
    if (formData.upload3) data.append("Upload3", formData.upload3);
    if (formData.upload4) data.append("Upload4", formData.upload4);

    data.append("Upload1_Name", formData.upload1_name);
    data.append("Upload2_Name", formData.upload2_name);
    data.append("Upload3_Name", formData.upload3_name);
    data.append("Upload4_Name", formData.upload4_name);

    try {
      const res = await api.post("/Master/AddNotice", data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
console.log("API Response:", res.data);
      setSuccessMsg("Notice submitted successfully!");
      setFormData({
        name: "",
        description: "",
        isHome: false,
        status_Info: 1,
        app_Web: "",
        remark: "",
        upload1: null,
        upload2: null,
        upload3: null,
        upload4: null,
        upload1_name: "",
        upload2_name: "",
        upload3_name: "",
        upload4_name: ""
      });
    } catch (err) {
      console.error(err);
      setErrorMsg("Error uploading notice. Please try again.");
    }
  };

  return (
    <div className="card shadow">
      <div className="card-header bg-primary text-white">
        <h4>Add Notice</h4>
      </div>

      <div className="card-body">
      {successMsg && <div style={{ color: "green" }}>{successMsg}</div>}
      {errorMsg && <div style={{ color: "red" }}>{errorMsg}</div>}
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="row">
          <div className="col-md-12 mb-3">
            <input
              type="text"
              name="name"
              placeholder="Notice Title"
              value={formData.name}
              onChange={handleChange}
              required
              className="form-control"
            />
          </div>

          <div className="col-md-12 mb-3">
            <textarea
              name="description"
              placeholder="Description"
              value={formData.description}
              onChange={handleChange}
              className="form-control"
            ></textarea>
          </div>
          {/* Upload Inputs */}
          {[1, 2, 3, 4].map((n) => (
            <React.Fragment key={n}>
              <div className="col-md-3 mb-3">
                <input
                  type="text"
                  name={`upload${n}_name`}
                  placeholder={`Upload${n} Name`}
                  value={formData[`upload${n}_name`]}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="col-md-3 mb-3">
                <input
                  type="file"
                  name={`upload${n}`}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              
            </React.Fragment>
          ))}

            {/* <input
              type="text"
              name="remark"
              placeholder="Remark"
              value={formData.remark}
              onChange={handleChange}
              className="form-control"
            /> */}
            {/* <div className="col-md-12 mb-3">
            <textarea
        name="remark"
        placeholder="Remarks"
        value={formData.remark}
        onChange={handleChange}
        className="form-control"
      ></textarea>
          </div> */}

<div className="col-md-12 mt-3 mb-3 text-center">
            <label>
              <input
                type="checkbox"
                name="isHome"
                checked={formData.isHome}
                onChange={handleChange}
              />{" "}
              Show on Home
            </label>
          </div>
          {/* <div className="col-md-12 mb-3 text-center">
            <input
              type="text"
              name="app_Web"
              placeholder="App/Web"
              value={formData.app_Web}
              onChange={handleChange}
              className="form-control"
            />
          </div> */}
          

          <div className="col-md-12 mb-3 text-center">
            <button type="submit" className="btn btn-primary">
              Submit Notice
            </button>
          </div>
        </div>
      </form>
    </div>
    </div>
  );
};

export default AddNotice;
